exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".valTip[data-v-23ec4deb] {\n  padding-left: 20px;\n  color: #f56c6c;\n}\n", ""]);

// exports
